module.exports = __webpack_public_path__ + "static/media/undraw_Programming_re_kg9v.9b8098b8.png";